import { useRef, useEffect } from "react";

const useInterval = (cb: Function, delay: number | null) => {
  const saveCallback = useRef<Function | null>(null);

  useEffect(() => {
    saveCallback.current = cb;
  }, [cb]);

  useEffect(() => {
    function tick() {
      if (saveCallback.current) {
        saveCallback.current();
      }
    }

    if (delay !== null) {
      const id = setInterval(tick, delay);

      return () => clearInterval(id);
    }
  }, [delay]);
};

export default useInterval;
